import React from 'react';

export default () => (
  <svg width="17px" height="17px" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
    <title>Advisory</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="HD-UX-GUI" transform="translate(-377.000000, -1299.000000)">
        <g id="Page-Messaing" transform="translate(367.000000, 1177.000000)">
          <g id="Error-Messaging" transform="translate(0.000000, 114.000000)">
            <g id="Imported-Layers-Copy-2" transform="translate(10.000000, 8.000000)">
              <g id="Rectangle-172-+-Fill-2">
                <path d="M8,0 L17,17 L0,17 L8,0 Z" id="Rectangle-172" fill="#FFC206" />
                <path
                  d="M7,5 L9.5,5 L9.5,8.34325851 L9.19829754,11.7692308 L7.27314848,11.7692308 L7,8.34325851 L7,
                  5 Z M7,16 L9.5,16 L9.5,13.4615385 L7,13.4615385 L7,16 Z"
                  id="Fill-2"
                  fill="#FFFFFF"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);